require('./stories');
require('./story');
require('./hero-autoplay');


// WEBPACK FOOTER //
// ./resources/assets/js/modules/videos/index.js